import { Pipe, PipeTransform } from '@angular/core';
import { SelectItem } from 'primeng/api';

@Pipe({
  name: 'multiselectKeyArrayToString'
})
export class MultiselectKeyArrayToStringPipe implements PipeTransform {

  transform(selectedItems: string[] = [], selectList: SelectItem[]): string {
    let valueString: string = '';
    if (selectedItems && selectedItems.length > 0) {
      selectedItems.map( value => {
        let listItem: SelectItem = selectList.find( item => item.value === value );
        if (listItem !== undefined) {
          valueString.length > 0 ? valueString = valueString + ', ' + listItem.label : valueString = valueString + listItem.label;
        }
      });
    }
    return valueString;
  }
}
